export default __webpack_public_path__ + "assets/images/10e30e67755e779906128bfa25832c84-signature-tutorial-second-page.png";